export default __webpack_public_path__ + "static/worker2-cd9c2e2c099bdead1b5381733fb17a95.jpg";